import React from "react"
import Navbar from "./global/navbar/navbar"

import "./bootstrap.min.css"
import "./layout.css"

import styled from "styled-components"

const Spacer = styled.div`
  padding: ${({ size }) => (size ? size : 2.5)}rem;
`

const Layout = ({ children }) => (
  <React.Fragment>
    <Navbar />
    <Spacer />
    {children}
  </React.Fragment>
)

export default Layout
